import { render, staticRenderFns } from "./carers-section.vue?vue&type=template&id=0463ae1d&scoped=true"
import script from "./carers-section.vue?vue&type=script&lang=js"
export * from "./carers-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463ae1d",
  null
  
)

export default component.exports